import ErrorStateActions from './constants';
import { IFieldValue, IActionObject } from './types';

const initialState: any = {};

export default function formStateReducer(
  state: any = initialState,
  action: IActionObject
): object {
  const { data } = action;
  switch (action.type) {
    case ErrorStateActions.SET_ERROR_STATE:
      // Overwrites state with new field key-val pairs
      return {
        ...data.reduce(
          (accumulatorState: any, { fieldKey, fieldValue }: IFieldValue) =>
            Object.assign(accumulatorState, { [fieldKey]: fieldValue }),
          state
        ),
      };
    case ErrorStateActions.RESET_ERROR_STATE:
      // Resets to Empty Object
      return {};
    default:
      return state;
  }
}
